import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { accordionTransitionTiming } from "@faire/retailer-visitor-shared/components/Accordion/Accordion";
import { AccordionContext } from "@faire/retailer-visitor-shared/components/Accordion/context";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { logError } from "@faire/web--source/common/logging";
import { useState } from "@faire/web--source/ui/hooks/useState";
import React, { useContext, useEffect, useLayoutEffect, useRef } from "react";
import styled, { css } from "styled-components";
/**
 * A component that only visually shows its children when its enclosing accordion is open.
 */ export var ExpandedContent = function(param) {
    var children = param.children, stopPropagation = param.stopPropagation;
    var ref = useRef(null);
    var context = useContext(AccordionContext);
    var _useState = _sliced_to_array(useState(0), 2), height = _useState[0], setHeight = _useState[1];
    useEffect(function() {
        if (context === null) {
            logError("Trying to use AccordionContext outside of a provider");
        }
    }, [
        context
    ]);
    useLayoutEffect(function() {
        var _getWindow;
        var computeHeight = debounceIfPossible(function() {
            var _ref_current;
            var _ref_current_clientHeight;
            setHeight((_ref_current_clientHeight = (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.clientHeight) !== null && _ref_current_clientHeight !== void 0 ? _ref_current_clientHeight : 0);
        });
        computeHeight();
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener("resize", computeHeight);
        return function() {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener("resize", computeHeight);
        };
    }, [
        children
    ]);
    return /*#__PURE__*/ _jsx(Wrapper, {
        $isOpen: !!context,
        $maxHeight: height,
        onClick: stopPropagation ? onClick : undefined,
        $stopPropagation: stopPropagation,
        children: /*#__PURE__*/ _jsx("div", {
            ref: ref,
            children: children
        })
    });
};
var onClick = function(e) {
    e.stopPropagation();
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-3c2947ed-0"
})([
    "max-height:",
    ";height:100%;overflow:hidden;@media (prefers-reduced-motion:no-preference){transition-property:max-height;",
    "}cursor:",
    ";"
], function(param) {
    var $isOpen = param.$isOpen, $maxHeight = param.$maxHeight;
    return(// eslint-disable-next-line no-nested-ternary
    $isOpen ? $maxHeight ? css([
        "",
        "px"
    ], $maxHeight) : "initial" : "0");
}, accordionTransitionTiming, function(param) {
    var $stopPropagation = param.$stopPropagation;
    return $stopPropagation ? "initial" : "unset";
});
